module.exports = __webpack_public_path__ + "img/other.156b4a9a.svg";